module.exports = __webpack_public_path__ + "img/Monitor.0beab2bb.svg";